<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs8>
        <h1 class="text-xs-left ma-3">{{title}}</h1>
      </v-flex>
    </v-layout>

    <div v-if="pointRequestList.length > 0">
      <v-layout row class="mx-3">
        <v-flex xs12>
          <template>
            <v-data-table
                :headers="headers"
                :items="pointRequestList"
                hide-actions
                class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  <span class="cursor-pointer" @click="$router.push('/points/security/edit/' + props.item.id)">{{ props.item.fact_address }}</span>
                </td>
                <td class="text-xs-left">{{ props.item.phone }}</td>
                <td class="text-xs-left">{{ props.item.legal_title !== null ? props.item.legal_title : ''}}</td>
                <td class="text-xs-left">{{ props.item.legal_address !== null ? props.item.legal_address : '' }}</td>
              </template>
            </v-data-table>
          </template>
        </v-flex>
      </v-layout>
    </div>

  </v-container>
</template>

<script>
  import HelpMixin from '../../mixins/help'

  export default {
    mixins: [HelpMixin],
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Активные заявки'}
        ],
        headers: [
          {
            text: 'Фактический адрес',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Телефон',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Юридическое лицо',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Юридический адрес',
            align: 'left',
            sortable: false,
            value: 'name'
          }
        ],
        pageDataReady: {
          isReady: false,
          requestList: false
        },
        title: 'Активные заявки'
      }
    },
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.requestList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)
        this.$store.dispatch('getPointRequestSecurityList')
          .then(() => {
            this.pageDataReady.requestList = true
            this.pageDataStatus()
          })
      }
    },
    computed: {
      pointRequestList () {
        this.$store.commit('setPageTitle', this.title)
        return this.$store.getters.pointRequestList
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Points/PointRequestSecurityList.vue